
import Swal from "sweetalert2";
import { granjaApi } from "../../api";








export const startUnidadMedidaXID = async(id) => {
    try {
        if( id === 'new') return null;
        const { data } = await granjaApi.get(`/unidadmedida/xid/${id}`);
        return data.data;
    } catch (error) {
        console.log(error)
        Swal.fire('Error', error.response.data.msg, 'error');
    }
}




export const startListadoMedidas = async({ page=0, termino='' }) => {
    try {
        const params = new URLSearchParams();
        params.append('page',  page.toString());
        params.append('termino',  termino);

        const { data } = await granjaApi.get('/unidadmedida', { params });
        // useBodegasStore.setState({ totalBodega: data.total });
        return data.data;

    } catch (error) {
        const errores = error.response.data['msg'] || error.response.data.errors[0]['msg'];
        throw new Error(errores);
    }
}




export const startSavingUniMedida = async(medida) => {
    try {
        if( medida.id ){
            await granjaApi.put(`/unidadmedida/${ medida.id }`, medida );
            Swal.fire('Exitoso', 'Medida Actualizada', 'success');
        }else {
            await granjaApi.post('/unidadmedida/new', medida);
            Swal.fire('Exitoso', 'Medida Creada', 'success');
            return true;
        }
    } catch (error) {
        console.log(error);
        Swal.fire('Error', error.response.data.msg, 'error');
        return false;
    }
}  

    


